const getImgUrl = (filename, type = 'img') => {
  if (!filename) return '/placeholder.jpg';
  if (filename.startsWith('http') || filename.startsWith('/')) return filename;

  const folder = type === 'product' ? 'product_img' : 'img';

  return `${process.env.REACT_APP_IMAGE_URL}/${folder}/${filename}`;
};

export default getImgUrl;